import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { getDatabase, connectDatabaseEmulator } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyAyvVteJLt2eCo-tfFoIheiSEJTCRqiYZc",
  authDomain: "scholar-crm-test-58d6c.firebaseapp.com",
  projectId: "scholar-crm-test-58d6c",
  storageBucket: "scholar-crm-test-58d6c.firebasestorage.app",
  messagingSenderId: "294891799974",
  appId: "1:294891799974:web:aa57640bd85449c7987b67",
  measurementId: "G-5W0YVLFZEQ",
  databaseURL: "https://scholar-crm-test-58d6c-default-rtdb.asia-southeast1.firebasedatabase.app/"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);
// Initialize Functions
const functions = getFunctions(app);
// Initialize Realtime Database
export const rtdb = getDatabase(app);

export { functions };

// If running the app locally with Firebase Emulator
// if (window.location.hostname === "localhost") {
//   connectFunctionsEmulator(functions, "localhost", 5001); // Change port if needed
//   connectFirestoreEmulator(db, "localhost", 8080);  // Change port if needed
//   connectAuthEmulator(auth, "http://localhost:9099"); // Auth emulator
//   connectDatabaseEmulator(rtdb, "localhost", 9000); // Realtime Database emulator
// }

// Connect to local emulators
// if (process.env.NODE_ENV === 'development') {
//   // connectFirestoreEmulator(db, 'localhost', 8080);
//   connectAuthEmulator(auth, 'http://localhost:9099');
//   connectFunctionsEmulator(functions, 'localhost', 5001);
// }


// Connect to local emulators
// if (process.env.NODE_ENV === 'development') {
//   connectFirestoreEmulator(db, 'localhost', 8080);
//   connectAuthEmulator(auth, 'http://localhost:9099');
//   connectFunctionsEmulator(functions, 'localhost', 5001);
// }
// const fetchCompanyUsersFunction = httpsCallable(functions, 'fetchCompanyUsers');

// Connect to Functions emulator in development
// if (process.env.NODE_ENV === 'development') {
//   connectFunctionsEmulator(functions, 'localhost', 5001);
// }